// SearchHeader.jsx
import React, { useEffect, useState } from 'react';
import { IoMdNotificationsOutline } from "react-icons/io";
import { FaArrowRight } from "react-icons/fa6";
import { DateTime } from "luxon";
import axiosInstance from "../../lib/axiosInstance";


import './Header1.css';

const Header1 = ({ branches = [], selectedBranchId = "", onBranchChange }) => {
    const [scheduledCount, setScheduledCount] = useState(null);
    const tz = process.env.REACT_APP_CLINIC_TZ || "Asia/Kolkata";

    useEffect(() => {
        let mounted = true;
        async function loadScheduled() {
            try {
                if (!selectedBranchId) {
                    if (mounted) setScheduledCount(0);
                    return;
                }
                const date = DateTime.now().setZone(tz).toISODate();
                const dateFrom = DateTime.fromISO(date, { zone: tz }).startOf("day").toUTC().toISO();
                const dateTo = DateTime.fromISO(date, { zone: tz }).endOf("day").toUTC().toISO();
                const res = await axiosInstance.get("/appointments", { params: { branchId: selectedBranchId, dateFrom, dateTo, status: "scheduled" } });
                const d = res && res.data ? res.data : res;
                const total = (d && typeof d.total === "number") ? d.total : (Array.isArray(d) ? d.length : 0);
                if (mounted) setScheduledCount(total);
            } catch (err) {
                if (mounted) setScheduledCount(0);
            }
        }
        loadScheduled();
        return () => { mounted = false; };
    }, [selectedBranchId, tz]);

    const todayLabel = DateTime.now().setZone(tz).toLocaleString(DateTime.DATE_MED);

    return (
        <div className="header">
            <div className="search-container">

                <p className='p-h2'>Billing & Invoices</p>
            </div>
            <div className='header-btns'>
                <select
                    value={selectedBranchId || ""}
                    onChange={(e) => onBranchChange && onBranchChange(e.target.value)}
                    style={{ padding: "8px 10px", borderRadius: 8, border: "1px solid #d1d5db", marginRight: 8 }}
                >
                    <option value="" disabled>Select branch</option>
                    {branches.map((b) => (
                        <option key={b._id || b.id} value={b._id || b.id}>
                            {b.name}
                        </option>
                    ))}
                </select>
                <div className="bookings-badge">
                    <span>•</span>
                    {scheduledCount == null ? "x" : scheduledCount} Bookings
                    <span><FaArrowRight/></span>
                    <div></div>
                </div>
                <div className='notif-icon'><IoMdNotificationsOutline /></div>

                <div className="date">Today, {todayLabel}</div>
            </div>
        </div>
    );
};

export default Header1;
